import { render } from "./chat_message.vue?vue&type=template&id=e0acb478"
import script from "./chat_message.js?vue&type=script&lang=js"
export * from "./chat_message.js?vue&type=script&lang=js"

import "./chat_message.vue?vue&type=style&index=0&id=e0acb478&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__